import { CloseIcon, Color, IconSize, MicOffIcon, MicOnIcon } from "@enxcs/dap-ui-stratos";
import { memo } from "react";

interface StatusIndicatorProps {
  isActive: boolean;
  isMuted: boolean;
  hasError: boolean;
}

export const StatusIndicator = memo(({ isActive, isMuted, hasError }: StatusIndicatorProps) => {
  return (
    <>
      {isActive && !hasError ? (
        isMuted ? (
          <MicOffIcon size={IconSize.V18} tone={Color.Neutral.V30} />
        ) : (
          <MicOnIcon size={IconSize.V18} tone={Color.Teal.V30} />
        )
      ) : (
        <CloseIcon size={IconSize.V18} tone={Color.Red.V40} />
      )}
    </>
  );
});
